/**
 * Renueva accessToken + refreshToken (cookies httpOnly) vía POST /refresh.
 * El access JWT dura ~15 min; esto evita cerrar sesión al primer 401.
 */
import { setWsToken } from '@/services/wsToken';

let refreshInFlight: Promise<boolean> | null = null;

export async function refreshSession(): Promise<boolean> {
    if (refreshInFlight) return refreshInFlight;

    refreshInFlight = (async () => {
        try {
            const res = await fetch('/refresh', { method: 'POST', credentials: 'include' });
            if (!res.ok) return false;
            const data = (await res.json()) as { wsToken?: string };
            if (data.wsToken) setWsToken(data.wsToken);
            return true;
        } catch {
            return false;
        } finally {
            refreshInFlight = null;
        }
    })();

    return refreshInFlight;
}

export async function endSessionAndGoToLogin(): Promise<void> {
    await fetch('/logout', { method: 'POST', credentials: 'include' }).catch(() => {});
    window.location.href = '/login';
}
